export default __webpack_public_path__ + "static/media/intro-java.3f53086f.jpg";